"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAllowedForRoles = void 0;
var _react = require("react");
var _shared = require("../shared");
var _ = require("./");
var useAllowedForRoles = function useAllowedForRoles() {
  var allowedRoles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _useAuth = (0, _shared.useAuth)(),
    user = _useAuth.user;
  var isAllowed = (0, _react.useMemo)(function () {
    return (0, _.isAllowedForRoles)(user, allowedRoles);
  }, [allowedRoles, user]);
  return {
    isAllowed: isAllowed
  };
};
exports.useAllowedForRoles = useAllowedForRoles;